/**
 * withOrderMethods
 * HOC for wrapping the provided component with OrderMethodsProvider
 */

import React from 'react'
import OrderMethodsProvider from './order-methods-provider'

export default function withOrderMethods(WrappedComponent) {
  return function OrderMethodsProviderHOC(props) {
    return (
      <OrderMethodsProvider>
        <WrappedComponent {...props} />
      </OrderMethodsProvider>
    )
  }
};
